import React from 'react';
import { Table } from 'react-bootstrap';
import Row from './components/Row';

const PushapiConfigTable = ({ configs, onRemove, onUpdate, onSort, partners }) => {
    const rows = configs.map((config, index) => <Row key={index} config={config} onUpdate={onUpdate} onRemove={onRemove} partners={partners}/>);

    return (
        <Table bordered responsive style={{ textAlign: 'center', verticalAlign: 'middle' }}>
            <thead>
                <tr>
                    <th onClick={() => onSort('affid')}>Affid</th>
                    <th onClick={() => onSort('name')}>Name</th>
                    <th onClick={() => onSort('partnerId')}>Partner</th>
                    <th onClick={() => onSort('zone')}>Zone</th>
                    <th onClick={() => onSort('type')}>Type</th>
                    <th onClick={() => onSort('monetization')}>Monetization</th>
                    <th onClick={() => onSort('creative')}>Creative</th>
                    <th onClick={() => onSort('auth')}>Auth</th>
                    <th onClick={() => onSort('factor')}>Factor</th>
                    <th onClick={() => onSort('weekendFactor')}>Weekend Factor</th>
                    <th onClick={() => onSort('roi')}>ROI</th>
                    <th onClick={() => onSort('mgidStyle')}>Mgid Style</th>
                    <th onClick={() => onSort('Paused')}>Paused</th>
                    <th>Action</th>
                </tr>
            </thead>
            <tbody>
                {rows}
            </tbody>
        </Table>
    )
};

export default PushapiConfigTable;


// WEBPACK FOOTER //
// ./src/scenes/PushapiConfig/components/Table/index.js